import styles from "@/elements-react/product-element/product-element.module.scss";
import { testid } from "@fixparts/testid/index";

interface ProductElementBrandProps {
  brand: string;
}

export const ProductElementBrand = (props: ProductElementBrandProps) => {
  const { brand } = props;

  return (
    <div className={styles.brand} {...testid({ block: "productCard", elm: "line", modifier: "brand" })}>
      {brand}
    </div>
  );
};
